import React from "react";
// import { allSteps } from "./saveInvoiceData";
import { Modal } from "react-bootstrap";
import classes from "./ObjectPlaygroundComponents.module.scss";

const StepsModal = ({ isModalOpen, onCloseModalHandler, stepsList }) => {
  return (
    <Modal
      show={isModalOpen}
      onHide={onCloseModalHandler}
      dialogClassName={`${classes["response-modal"]}`}
    >
      <h4>Steps</h4>
      <div className={classes.overflow}>
        <h5>Country default</h5>
        <table className="table pb-5">
          <thead>
            <tr className={classes.blueText}>
              <th scope="col">Step</th>
              <th scope="col">Description</th>
              {/* <th scope="col">Required steps</th> */}
            </tr>
          </thead>
          <tbody>
            {stepsList
              .filter((step) => step.Step === '999')
              .map((step, index) => (
                <tr key={`step-no-${index}`}>
                  <th scope="row" className={classes.blueText}>
                    {step.Step}
                  </th>
                  {/* <td>{step.description}</td> */}
                  <td>{step.StepDescription}</td>
                  {/* <td>{step.rqd}</td> */}
                </tr>
              ))}
          </tbody>
        </table>
        <h5>Other steps</h5>
        <table className="table pb-5">
          <thead>
            <tr className={classes.blueText}>
              <th scope="col">Step</th>
              <th scope="col">Description</th>
              {/* <th scope="col">Required steps</th> */}
            </tr>
          </thead>
          <tbody>
            {stepsList
              .filter((step) => step.step !== 999)
              .map((step, index) => (
                <tr key={`other-step-${index}`}>
                  <th scope="row" className={classes.blueText}>
                    {step.Step}
                  </th>
                  {/* <td>{step.description}</td> */}
                  <td>{step.StepDescription}</td>
                  {/* <td>{step.rqd}</td> */}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </Modal>
  );
};

export default StepsModal;
